import { useCallback, useState } from 'react';
import { useQuery } from 'data-fetching-client';
import { FETCH_TOP_POSITIVE_SPOTLIGHTS } from 'messaging-publishing-lib/Insights/queries';
import { isSupportedSpotlight } from 'messaging-publishing-lib/Insights/utils/support';
export const filterUnsupportedData = response => {
  const spotlights = response.spotlights.filter(isSupportedSpotlight);
  return Object.assign({}, response, {
    spotlights,
    countOfSpotlightsInResponse: spotlights.length
  });
};
const useFetchTopPositiveSpotlights = variables => {
  const [fetchMoreLoading, setFetchMoreLoading] = useState(false);
  const [fetchedMoreBefore, setFetchedMoreBefore] = useState(false);
  const [fetchMoreError, setFetchMoreError] = useState();
  const {
    data,
    loading,
    error,
    fetchMore
  } = useQuery(FETCH_TOP_POSITIVE_SPOTLIGHTS, {
    variables
  });
  const fetchMoreWithState = useCallback(async () => {
    setFetchMoreLoading(true);
    setFetchedMoreBefore(true);
    try {
      const latestTimestamp = data === null || data === void 0 ? void 0 : data.topPositiveInsights.earliestTimestamp;
      await fetchMore({
        variables: Object.assign({}, variables, {
          latestTimestamp
        }),
        updateQuery(previousData, {
          fetchMoreResult
        }) {
          return {
            topPositiveInsights: Object.assign({}, fetchMoreResult.topPositiveInsights, {
              countOfSpotlightsInResponse: previousData.topPositiveInsights.countOfSpotlightsInResponse + fetchMoreResult.topPositiveInsights.countOfSpotlightsInResponse,
              spotlights: [...previousData.topPositiveInsights.spotlights, ...fetchMoreResult.topPositiveInsights.spotlights]
            })
          };
        }
      });
    } catch (e) {
      setFetchMoreError(e);
    } finally {
      setFetchMoreLoading(false);
    }
  }, [data, fetchMore, variables]);
  return {
    data: data ? filterUnsupportedData(data.topPositiveInsights) : undefined,
    loading,
    error,
    fetchMore: fetchMoreWithState,
    fetchMoreLoading,
    fetchMoreError,
    fetchedMoreBefore
  };
};
export default useFetchTopPositiveSpotlights;